<div class="slots-container">
  <ng-content></ng-content>
</div>
